import EditorViewer from "../codesnippet/RTEEditorViewer";
import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import "./Posts.css";
import PostActions from "../../components/LikeCommentActions";
import { Plus, X } from "lucide-react";
import DropdownActions from "../../components/DropdownActions";
import { useParams } from "react-router-dom";

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newContent, setNewContent] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const modalRef = useRef(null);
  const { userId: id } = useParams();

  const token = localStorage.getItem("access_token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const fetchCurrentUser = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY, },
      });
      const data = await res.json();
      if (res.ok) {
        setCurrentUser(data.data);
        setCurrentUserId(data.data.id);
        localStorage.setItem("user_id", data.data?.user);
      } else {
        console.error("Failed to fetch current user");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error getting user profile.");
    }
  }, [BASE_URL, token]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  // const fetchPosts = useCallback(async () => {
  //   try {
  //     const res = await axios.get(`${BASE_URL}/user/posts/`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setPosts(res.data?.results || []);
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to load posts");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [BASE_URL, token]);

  const fetchPosts = useCallback(
    async (userId = null) => {
      setLoading(true);
      try {
        let postsFromApi = [];
        if (userId) {
          const res = await axios.get(
            `${BASE_URL}/user/profile/all-profiles/?id=${userId}`,
            {
              headers: { 
                Authorization: `Bearer ${token}`,
                "x-api-key": process.env.REACT_APP_X_API_KEY 
              },
            }
          );
          postsFromApi = res.data?.data?.posts || [];
        } else {
          const res = await axios.get(`${BASE_URL}/user/posts/?type=my_posts`, {
            headers: { 
              Authorization: `Bearer ${token}`, 
              "x-api-key": process.env.REACT_APP_X_API_KEY 
            },
          });
          postsFromApi = res.data?.results || [];
        }

        const normalizedPosts = postsFromApi.map((post) => ({
          ...post,
        }));

        setPosts(normalizedPosts);
      } catch (err) {
        console.error("Failed to fetch posts", err);
        toast.error("Failed to load posts");
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, token]
  );

  useEffect(() => {
    fetchPosts(id);
  }, [fetchPosts, id]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsAddModalOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleEditPost = (post) => {
    setEditingPost(post);
    setNewTitle(post.title);
    setNewContent(post.content);
    setIsAddModalOpen(true);
  };

  const handleSavePost = async () => {
    if (!newTitle.trim() || !newContent.trim()) {
      toast.error("Title and content cannot be empty");
      return;
    }

    try {
      setCreating(true);
      if (editingPost) {
        await axios.patch(
          `${BASE_URL}/user/posts/`,
          { id: editingPost.id, title: newTitle, content: newContent },
          { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
        );
        toast.success("Post updated successfully!");
      } else {
        await axios.post(
          `${BASE_URL}/user/posts/`,
          { title: newTitle, content: newContent, post_type: "normal" },
          { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
        );
        toast.success("Post created successfully!");
      }
      fetchPosts(id);
      setNewTitle("");
      setNewContent("");
      setEditingPost(null);
      setIsAddModalOpen(false);
    } catch (err) {
      console.error(err);
      toast.error(
        editingPost ? "Failed to update post" : "Failed to create post"
      );
    } finally {
      setCreating(false);
    }
  };

  const handleDeletePost = async (postId) => {
    try {
      await axios.delete(`${BASE_URL}/user/posts/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
        data: { id: postId },
      });
      toast.success("Post deleted!");
      fetchPosts(id);
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete post");
    }
  };

  if (loading)
    return (
      <div className="normal-post-loading">
        <ClipLoader color="#4A90E2" size={40} />
      </div>
    );

  console.log("All posts:", posts);
  console.log("Current User ID:", currentUserId);

  return (
    // <div className="normal-posts-container">
    //   <div className="add-post-button-wrapper">
    //     {!id && (
    //       <button
    //         className="images-upload-btn"
    //         onClick={() => setIsAddModalOpen(true)}
    //       >
    //         <Plus size={18} />
    //       </button>
    //     )}
    //   </div>

    //   {posts.length === 0 && <p>No posts yet</p>}
    //   {currentUserId &&
    //     posts
    //       .filter((post) => post.post_type === "normal")
    //       .map((post) => (
    //         <div key={post.id} className="normal-post-card">
    //           {Number(post.user?.profile_id) === Number(currentUserId) && (
    //             <div className="dropdown-wrapper">
    //               <DropdownActions
    //                 onEdit={() => handleEditPost(post)}
    //                 onDelete={() => handleDeletePost(post.id)}
    //               />
    //             </div>
    //           )}
    //           <h3>{post.title}</h3>
    //           <div dangerouslySetInnerHTML={{ __html: post.content }} />
    //           <PostActions
    //             postId={post.id}
    //             type="post"
    //             is_Liked={post.is_liked === true}
    //             likeCount={post.like_count ?? post.total_likes ?? 0}
    //             currentUser={currentUserId}
    //           />
    //         </div>
    //       ))}

    //   {isAddModalOpen && (
    //     <div className="modal-overlay">
    //       <div className="modal-content" ref={modalRef}>
    //         <X
    //           className="modal-close-icon"
    //           onClick={() => setIsAddModalOpen(false)}
    //         />
    //         <h3>Create Post</h3>
    //         <input
    //           type="text"
    //           placeholder="Post Title"
    //           className="normal-post-input"
    //           value={newTitle}
    //           onChange={(e) => setNewTitle(e.target.value)}
    //         />
    //         <div style={{ direction: "ltr", textAlign: "left" }}>
    //           <EditorViewer
    //             value={newContent}
    //             readOnly={false}
    //             setValue={setNewContent}
    //           />
    //         </div>
    //         <button
    //           className="normal-post-btn"
    //           onClick={handleSavePost}
    //           disabled={creating}
    //         >
    //           {creating
    //             ? editingPost
    //               ? "Saving..."
    //               : "Posting..."
    //             : editingPost
    //             ? "Save"
    //             : "Post"}
    //         </button>
    //       </div>
    //     </div>
    //   )}
    // </div>
    <div className="w-full max-w-[1050px]">
      <div className="flex justify-end mb-5">
        {!id && (
          <button
            className="bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center"
            onClick={() => setIsAddModalOpen(true)}
          >
            <Plus size={18} />
          </button>
        )}
      </div>


      {/* No Posts Message */}
      {posts.length === 0 && (
        <div className="flex flex-col justify-center items-center py-12 bg-white rounded-xl border border-gray-200">
          <div className="w-16 h-16 bg-[#e8f0f7] rounded-xl flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No posts yet</h3>
          <p className="text-gray-500 text-sm mb-4">Be the first to create a post</p>
        </div>
      )}

      {/* Posts List */}
      {posts
        .filter((post) => post.post_type === "normal")
        .map((post) => (
          <div
            key={post.id}
            className="relative bg-white border border-gray-200 rounded-xl p-5 mb-4 shadow-sm hover:-translate-y-1 transition-transform"
          >
            {currentUserId && Number(post.user?.profile_id) === Number(currentUserId) && (
                <div className="absolute top-[-25px] right-0 mb-2">
                  <DropdownActions
                    onEdit={() => handleEditPost(post)}
                    onDelete={() => handleDeletePost(post.id)}
                  />
                </div>
              )}
              <div className="ml-2 inline-flex items-center gap-2 mb-3   rounded">
                <h1 className="text-lg font-bold text-gray-900">
                  {post.title}
                </h1>
              </div>


              {/* <div
            className="text-sm text-text-secondary leading-relaxed"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
         */}
              <div>

                <div className="prose prose-lg max-w-none bg-white p-6 rounded-xl  border border-gray-50">
                  <div
                    className="text-gray-800 leading-relaxed text-lg"
                    dangerouslySetInnerHTML={{
                      __html: post.content?.replace(/<\/?p>/g, ''),
                    }}
                  />
                </div>
                <PostActions
                  postId={post.id}
                  type="post"
                  is_Liked={post.is_liked === true}
                  likeCount={post.like_count ?? post.total_likes ?? 0}
                  currentUser={currentUserId}
                />
              </div>
            </div>
          ))}

      {/* Add/Edit Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4">
          <div
            className="bg-white rounded-2xl w-full max-w-lg shadow-xl mt-6"
            ref={modalRef}
          >
            {/* Header */}
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Create Post</h3>
                    <p className="text-sm text-gray-500 mt-0.5">Share your thoughts with the community</p>
                  </div>
                </div>
                <button
                  className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Post Title</label>
                <input
                  type="text"
                  placeholder="Enter a title for your post"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">Post Content</label>
                <div className="ltr text-left">
                  <EditorViewer
                    value={newContent}
                    readOnly={false}
                    setValue={setNewContent}
                  />
                </div>
              </div>

              <button
                className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleSavePost}
                disabled={creating}
              >
                {creating ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    {editingPost ? "Saving..." : "Posting..."}
                  </>
                ) : (
                  <>
                    {editingPost ? (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Save Changes
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Publish Post
                      </>
                    )}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default Posts;
